import { FC } from 'react'
import { IStatusPill } from 'types/ui/statusPill.interface'
import { StyledStatusPill } from './StatusPill.styled'

export const StatusPill: FC<IStatusPill> = ({ status, dot, children }) => {
  return (
    <StyledStatusPill $status={status} $dot={dot}>
      {children}
    </StyledStatusPill>
  )
}
